import React from "react";
import { cx } from "@linaria/core";
import {
  StyledWrapper,
  Subcopy,
  StyledRadio,
  StyledCheckbox
} from "./SelectableTile.styles";
const FormElement = ({ type, ...restProps }) => {
  if (type === "checkbox") {
    return /* @__PURE__ */ React.createElement(StyledCheckbox, {
      ...restProps
    });
  }
  return /* @__PURE__ */ React.createElement(StyledRadio, {
    ...restProps
  });
};
const SelectableTile = ({
  type = "radio",
  id,
  label,
  subcopy,
  children,
  value,
  disabled,
  checked,
  onClick
}) => {
  const handleClick = (ev) => {
    const isInput = ev?.target?.tagName === "INPUT";
    if (isInput) {
      return;
    }
    onClick?.(ev);
  };
  return /* @__PURE__ */ React.createElement(StyledWrapper, {
    className: cx(checked && "is-checked", disabled && "disabled", subcopy && "subcopy", children && "children"),
    onClick: handleClick
  }, /* @__PURE__ */ React.createElement(FormElement, {
    type,
    id,
    label,
    value,
    checked,
    disabled
  }), /* @__PURE__ */ React.createElement(Subcopy, {
    className: cx(disabled && "disabled")
  }, subcopy), children);
};
export default SelectableTile;
